const currentUrl = window.location.href.toLowerCase();

const isStaging =
  currentUrl.includes("hml") ||
  currentUrl.includes("localhost") ||
  currentUrl.includes("staging") ||
  currentUrl.includes("192"); //when running localhost on ReactNatie with IP.

export const API_URL = `https://apiv2${
  isStaging ? "-dev" : ""
}.orthodonticbrasil.com/api/`;

export const DEFAULT_AVATAR =
  "https://ksastcorpsites.blob.core.windows.net/site/general/63711513335168-image.jpg";
